import { Directive, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { PortalSettingsService } from 'src/app/core/services/portal-settings.service';

@Directive({
  selector: '[appSsnFormat]',
  host: {
    '(keyup)': 'validateSSN($event,true)',
    '(blur)': 'validateSSN($event,false)',
  },
})
export class SsnFormatDirective {
  portalSetting: any;
  @Input() value: string;
  @Output() valueChange = new EventEmitter<string>();

  constructor(
    private elementRef: ElementRef,
    private portalSettingService: PortalSettingsService
  ) {
    this.portalSetting = portalSettingService.getPortalSettings();
  }

  validateSSN(event: any, type: boolean) {
    if (type) {
      var mask = '';
      var country = this.portalSetting.CountryDateCode.ConfigValue;
      switch (country.toUpperCase()) {
        case 'US':
          mask = '999-99-9999';
          break;
        case 'CAN':
        case 'CA':
          mask = '999-999-999';
          break;
        default:
          mask = '999-99-9999';
          break;
      }

      var maskLength = mask.replace(/[\D\s]/gi, '').length;
      var newVal = event.target.value.replace(/[^\d|-]/gi, '');
      var newVal = newVal.replace(/[\D\s]/gi, '');
      this.value = '';
      for (var i = 0; i < newVal.length; i++) {
        if (i >= maskLength) {
          break;
        }
        if (country == 'US') {
          if (i == 3 || i == 5) {
            this.value += '-' + newVal.charAt(i);
          } else {
            this.value += newVal.charAt(i);
          }
        } else if (country == 'CA' || country == 'CAN') {
          if (i == 3 || i == 6) {
            this.value += '-' + newVal.charAt(i);
          } else {
            this.value += newVal.charAt(i);
          }
        } else {
          if (i == 3 || i == 5) {
            this.value += '-' + newVal.charAt(i);
          } else {
            this.value += newVal.charAt(i);
          }
        }
      }
      this.elementRef.nativeElement.setAttribute('value', this.value);
      this.valueChange.emit(this.value);
    } else {
      var mask = '';
      switch (this.portalSetting.CountryDateCode.ConfigValue.toUpperCase()) {
        case 'US':
          mask = '999-99-9999';
          break;
        case 'CAN':
        case 'CA':
          mask = '999-999-999';
          break;
        default:
          mask = '999-99-9999';
          break;
      }
      if (!mask || mask == '' || mask == undefined) {
        return;
      } else {
        var maskLength = mask.replace(/[^\w\s]/gi, '').length;
        var origVal = event.target.value.replace(/[\D\s]/gi, '');
        $(this).val(origVal);
        var maskedEntry = '';
        var inputChar = 0;

        if (origVal.length >= maskLength) {
          for (var i = 0; i < mask.length; i++) {
            if (mask.charAt(i) == '9') {
              maskedEntry += origVal.charAt(inputChar);
              inputChar++;
            } else {
              maskedEntry += mask.charAt(i);
            }
          }
          $(this).val(maskedEntry);
        } else {
          this.elementRef.nativeElement.setAttribute('value', this.value);
          this.valueChange.emit(this.value);
        }
      }
    }
  }
}
